// @flow
import { connect } from 'react-redux';

import { hideErrorMessage } from 'actions/errorMessage';
import ErrorMessage from './ErrorMessage';

const mapStateToProps = ({ errorMessage }) => errorMessage;

const mapDispatchToProps = { hideErrorMessage };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorMessage);



// WEBPACK FOOTER //
// ./components/ErrorMessage/index.js